/*
* 路由路 菜单明细-由 c、s端共通拥有
*/
export default [
  {
    path: '/index',
    name:"index",
    component: () => import('@/views/Index'),
    redirect:'/home',
    meta: {
      title: '首页',
      icon: null,
      requireAuth:true,//表示进入这个路由是否需要登录验证
    },
    children: [
      //系统起始页面
      {
        path: '/home',
        name:"home",
        component: () => import('@/views/home'),
        meta: {
          title: '',
          icon: null,
          menuId:0,
          requireAuth:true,//表示进入这个路由是否需要登录验证
        }
      },
      //NRI菜单组
      {
        path: '/nri',
        name:"nri",
        component: () => import('@/views/nri/index'),
        meta: {
          title: 'NRI',
          icon: null,
          menuId:1,
          requireAuth:true,//表示进入这个路由是否需要登录验证
        },
        children: [
          {
            path: '/user-special',
            name:"user-special",
            component: () => import('@/views/nri/user-manage/special'),
            meta: {
              title: '特殊权限设定',
              menuId:4,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/user-group-menu',
            name:"user-group-menu",
            component: () => import('@/views/nri/user-manage/user-group-menu'),
            meta: {
              title: '用户组菜单',
              menuId:43,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/use-charge',
            name:"use-charge",
            component: () => import('@/views/nri/use-charge'),
            meta: {
              title: '使用费查询',
              menuId:3,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          }
        ]
      },
      //信息共享菜单组
      {
        path: '/info-share',
        name:"info-share",
        component: () => import('@/views/info-share/index'),
        meta: {
          title: '信息共享',
          icon: null,
          menuId:5,
          requireAuth:true,//表示进入这个路由是否需要登录验证
        },
        children: [
          {
            path: '/commodity',
            name:"commodity",
            component: () => import('@/views/info-share/commodity/index'),
            meta: {
              title: '新商品推荐',
              menuId:13,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children: [
              {
                //默认页面，载入后第一个组件 使用空path，
                path: '',
                name:"",
                component: () =>  import('@/views/info-share/commodity/list'),
                meta: {
                  title: '',//查询画面 title 为空 则导航栏不会显示该内容
                  menuId:13,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/commodity-detail',
                name:"commodity-detail",
                component: () =>  import('@/views/info-share/commodity/detail'),
                meta: {
                  title: '新商品详细信息',
                  menuId:13,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/commodity-add',
                name:"commodity-add",
                component: () =>  import('@/views/info-share/commodity/add'),
                meta: {
                  title: '新商品登录',
                  menuId:13,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
            ]
          },
          {
            path: '/info-share-help',
            name:"info-share-help",//也是路径 不应该是中文
            component: () => import('@/views/info-share/help/index'),
            meta: {
              title: '帮助',
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children: [
              {
                path: '',
                name:"",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/def-index'),
                meta: {
                  title: '信息共享帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/item-help',
                name:"item-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/item-help/index'),
                meta: {
                  title: '单品进销存-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/lastorder-help',
                name:"lastorder-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/lastorder-help/index'),
                meta: {
                  title: '最终订货查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/311order-help',
                name:"311order-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/311order-help/index'),
                meta: {
                  title: '311订货单查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/storder-help',
                name:"storder-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/storder-help/index'),
                meta: {
                  title: 'ST订货单查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/ckorder-help',
                name:"ckorder-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/ckorder-help/index'),
                meta: {
                  title: '中央厨房订货单查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/delivery-help',
                name:"delivery-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/delivery-help/index'),
                meta: {
                  title: '进退货查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/transferbills-help',
                name:"transferbills-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/transferbills-help/index'),
                meta: {
                  title: '转账单查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/in-shop-help',
                name:"in-shop-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/in-shop-help/index'),
                meta: {
                  title: '店中店修正传票查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/calendar-help',
                name:"calendar-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/calendar-help/index'),
                meta: {
                  title: '业务日历-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/notice-help',
                name:"notice-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/notice-help/index'),
                meta: {
                  title: '业务通知-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/commodity-help',
                name:"commodity-help",//也是路径 不应该是中文
                component: () => import('@/views/info-share/help/commodity-help/index'),
                meta: {
                  title: '新商品推荐-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
            ]
          },
          {
            path: '/lastorder',
            name:"lastorder",//也是路径 不应该是中文
            component: () => import('@/views/info-share/lastorder'),
            meta: {
              title: '最终订货查询',
              icon: null,
              menuId:7,//db表中菜单对应的id 用来做系统日志使用
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/instantorder',
            name:"instantorder",//也是路径 不应该是中文
            component: () => import('@/views/info-share/instantorder/index'),
            meta: {
              title: '即时订货查询',
              icon: null,
              menuId:8,//db表中菜单对应的id 用来做系统日志使用
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children: [
              {
                path: '/311order',
                name:"311order",
                component: () => import('@/views/info-share/instantorder/311order'),
                meta: {
                  title: '311订货单查询',
                  menuId:15,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/storder',
                name:"storder",
                component: () => import('@/views/info-share/instantorder/storder'),
                meta: {
                  title: 'ST订货单查询',
                  menuId:16,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/ckorder',
                name:"ckorder",
                component: () => import('@/views/info-share/instantorder/ckorder'),
                meta: {
                  title: '中央厨房订货单查询',
                  menuId:17,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              }
            ]
          },
          {
            path: '/delivery',
            name:"delivery",
            component: () => import('@/views/info-share/delivery'),
            meta: {
              title: '进退货查询',
              menuId:9,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children:[
                {
                    path: '',
                    name:"",
                    component: () => import('@/views/info-share/delivery/list'),
                    meta: {
                      title: '查询合计',
                      menuId:9,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/delivery-detail',
                    name:"delivery-detail",
                    component: () => import('@/views/info-share/delivery/detail'),
                    meta: {
                      title: '查询详细',
                      menuId:9,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
            ]
          },
          {
            path: '/item',
            name:"item",
            component: () => import('@/views/info-share/item-sale-stock'),
            meta: {
              title: '单品进销存',
              menuId:6,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children:[
                {
                    path: '',
                    name:"",
                    component: () => import('@/views/info-share/item-sale-stock/list'),
                    meta: {
                      title: '查询结果一览',
                      menuId:6,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
            ]
          },
          {
            path: '/calendar',
            name:"calendar",
            component: () => import('@/views/info-share/business-calendar'),
            meta: {
              title: '业务日历',
              menuId:11,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children:[
                {
                    path: '',
                    name:"",
                    component: () => import('@/views/info-share/business-calendar/calendar'),
                    meta: {
                      title: '',
                      menuId:11,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/edit-sale-plan',
                    name:"edit-sale-plan",
                    component: () => import('@/views/info-share/business-calendar/editSalePlan'),
                    meta: {
                      title: '销售/促销计划',
                      menuId:11,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
            ]
          },
          {
            path: '/notice',
            name:"notice",
            component: () => import('@/views/info-share/business-notice'),
            meta: {
              title: '业务通知',
              menuId:12,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children:[
                {
                    path: '',
                    name:"",
                    component: () => import('@/views/info-share/business-notice/list'),
                    meta: {
                      title: '',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/notice-detail',
                    name:"notice-detail",
                    component: () => import('@/views/info-share/business-notice/detail'),
                    meta: {
                      title: '详细信息',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/notice-edit',
                    name:"notice-edit",
                    component: () => import('@/views/info-share/business-notice/edit'),
                    meta: {
                      title: '编辑新通知',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/notice-preview',
                    name:"notice-preview",
                    component: () => import('@/views/info-share/business-notice/preview'),
                    meta: {
                      title: '预览新通知',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/reply-detail',
                    name:"reply-detail",
                    component: () => import('@/views/info-share/business-notice/replyDetail'),
                    meta: {
                      title: '回复情况',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/vendor-limit',
                    name:"vendor-limit",
                    component: () => import('@/views/info-share/business-notice/vendorLimit'),
                    meta: {
                      title: '供应商范围',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
                {
                    path: '/vendor-reply',
                    name:"vendor-limit",
                    component: () => import('@/views/info-share/business-notice/vendorReply'),
                    meta: {
                      title: '通知详细',
                      menuId:12,//db表中菜单对应的id 用来做系统日志使用
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                },
            ]
          },
          {
            path: '/transfer',
            name:"transfer",
            component: () => import('@/views/info-share/transfer/index'),
            meta: {
              title: '转账单通知查询',
              menuId:10,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            },
            children: [
              {
                path: '/transferbills',
                name:"transferbills",
                component: () => import('@/views/info-share/transfer/transferbills/index'),
                meta: {
                  title: '转账单查询',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                },
                children: [
                  {
                    //默认页面，载入后第一个组件 使用空path，
                    path: '',
                    name:"",
                    component: () =>  import('@/views/info-share/transfer/transferbills/list'),
                    meta: {
                      title: '',//查询画面 title 为空 则导航栏不会显示该内容
                      icon: null,
                      menuId:18,//db表中菜单对应的id 用来做系统日志使用
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                  },
                  {
                    path: '/transferbills-info-show',
                    name:"transferbills-info-show",
                    component: () =>  import('@/views/info-share/transfer/transferbills/transferbills-info-show'),
                    meta: {
                      title: '转账单信息显示',
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                  },
                  {
                    path: '/transferbills-transfer-show',
                    name:"transferbills-transfer-show",
                    component: () =>  import('@/views/info-share/transfer/transferbills/transferbills-transfer-show'),
                    meta: {
                      title: '明细单信息显示',
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                  }
                ]
              },
              {
                path: '/in-shop',
                name:"in-shop",
                component: () => import('@/views/info-share/transfer/in-shop/index'),
                meta: {
                  title: '店中店修正传票查询',
                  menuId:19,//db表中菜单对应的id 用来做系统日志使用
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                },
                children: [
                  {
                    //默认页面，载入后第一个组件 使用空path，
                    path: '',
                    name:"",
                    component: () =>  import('@/views/info-share/transfer/in-shop/list'),
                    meta: {
                      title: '',//查询画面 title 为空 则导航栏不会显示该内容
                      icon: null,
                      menuId:19,//db表中菜单对应的id 用来做系统日志使用
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                  },
                  {
                    path: '/in-shop-detail',
                    name:"in-shop-detail",
                    component: () =>  import('@/views/info-share/transfer/in-shop/detail'),
                    meta: {
                      title: '传票查询明细',
                      icon: null,
                      requireAuth:true,//表示进入这个路由是否需要登录验证
                    }
                  }
                ]
              }
            ]
          },
        ]
      },
      //支付相关菜单组
      {
        path: '/payment',
        name:"payment",
        component: () => import('@/views/payment/index'),
        meta: {
          title: '支付相关',
          icon: null,
          menuId:20,
          requireAuth:true,//表示进入这个路由是否需要登录验证
        },
        children: [
          {
            path: '/invoice',
            name:"invoice",
            component: () => import('@/views/payment/invoice'),
            meta: {
              title: '发票查询',
              menuId:22,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/vendormgr',
            name:"vendormgr",
            component: () => import('@/views/payment/vendor/manager'),
            meta: {
              title: '系统供应商查询',
              menuId:30,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
        ]
      },
      //商品信息管理 菜单组
      {
        path: '/goods-info-manage',
        name:"goods-info-manage",
        component: () => import('@/views/goods-info-manage/index'),
        meta: {
          title: '商品信息管理',
          icon: null,
          menuId:33,
          requireAuth:true,//表示进入这个路由是否需要登录验证
        },
        children: [
          {
            path: '/goods-register',
            name:"goods-register",
            component: () => import('@/views/goods-info-manage/goods-register/index'),
            meta: {
              title: '商品基础信息登录',
              menuId:34,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/goods-query',
            name:"goods-query",
            component: () => import('@/views/goods-info-manage/goods-query/index'),
            meta: {
              title: '商品基础信息查询',
              menuId:35,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/goods-his-query',
            name:"goods-his-query",
            component: () => import('@/views/goods-info-manage/goods-his-query/index'),
            meta: {
              title: '商品历史信息查询',
              menuId:36,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/goods-info-manage-help',
            name: "goods-info-manage-help",//也是路径 不应该是中文
            component: () => import('@/views/goods-info-manage/help/index'),
            meta: {
              title: '帮助',
              icon: null,
              requireAuth: true,//表示进入这个路由是否需要登录验证
            },
            children: [
              {
                path: '/',
                name:"",
                component: () => import('@/views/goods-info-manage/help/def-index.vue'),
                meta: {
                  title: '商品信息管理帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/goods-register-help',
                name:"goods-register-help",
                component: () => import('@/views/goods-info-manage/help/goods-register-help/index.vue'),
                meta: {
                  title: '商品基础信息登录-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/goods-query-help',
                name:"goods-query-help",
                component: () => import('@/views/goods-info-manage/help/goods-query-help/index.vue'),
                meta: {
                  title: '商品基础信息查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
              {
                path: '/goods-his-query-help',
                name:"goods-his-query-help",
                component: () => import('@/views/goods-info-manage/help/goods-his-query-help/index.vue'),
                meta: {
                  title: '商品历史记录查询-帮助',
                  icon: null,
                  requireAuth:true,//表示进入这个路由是否需要登录验证
                }
              },
            ]
          }
        ]
      },
      //其他系统 菜单组
      {
        path: '/system-other',
        name:"system-other",
        component: () => import('@/views/system-other/index'),
        meta: {
          title: '其他系统',
          icon: null,
          menuId:38,
          requireAuth:true,//表示进入这个路由是否需要登录验证
        },
        children: [
          {
            path: '/skip-et',
            name:"skip-et",
            component: () => import('@/views/system-other/et/index'),
            meta: {
              title: '电子传票',
              menuId:39,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/skip-qc',
            name:"skip-qc",
            component: () => import('@/views/system-other/qc/index'),
            meta: {
              title: '证照系统',
              menuId:40,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/skip-allet',
            name:"skip-allet",
            component: () => import('@/views/system-other/allet/index'),
            meta: {
              title: '支付相关-全电发票',
              menuId:41,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          },
          {
            path: '/skip-master',
            name:"skip-master",
            component: () => import('@/views/system-other/master/index'),
            meta: {
              title: 'master系统',
              menuId:42,//db表中菜单对应的id 用来做系统日志使用
              icon: null,
              requireAuth:true,//表示进入这个路由是否需要登录验证
            }
          }
        ]
      }
    ]
  },
  //打印容器入口
  {
    path:"/print",
    name: 'print',
    component: () => import('@/views/exception/print'),
    meta: {
      title: '打印',
      icon: null,
      requireAuth:false,//表示进入这个路由是否需要登录验证
    }
  },
  //公共帮助页面载入入口
  {
    path:"/common-help",
    name: 'common-help',
    component: () => import('@/views/common-help/index'),
    meta: {
      title: '帮助',
      icon: null,
      requireAuth:false,//表示进入这个路由是否需要登录验证
    },
    children: [
      {
        path: '/common-help-qa',
        name:"common-help-qa",
        component: () => import('@/views/common-help/QA/index'),
        meta: {
          title: '常见问题及解答',
          icon: null,
          requireAuth:false,//表示进入这个路由是否需要登录验证
        }
      },
      {
        path: '/common-help-esc',
        name:"common-help-esc",
        component: () => import('@/views/common-help/esc/index'),
        meta: {
          title: '浏览器环境设定',
          icon: null,
          requireAuth:false,//表示进入这个路由是否需要登录验证
        }
      },
      {
        path: '/common-help-register',
        name:"common-help-register",
        component: () => import('@/views/common-help/register/index'),
        meta: {
          title: '供应商新EDI安装手顺',
          icon: null,
          requireAuth:false,//表示进入这个路由是否需要登录验证
        }
      },
      {
        path: '/common-help-invoice',
        name:"common-help-invoice",
        component: () => import('@/views/common-help/invoice/index'),
        meta: {
          title: '增值税专用发票开具资料',
          icon: null,
          requireAuth:false,//表示进入这个路由是否需要登录验证
        }
      },
      //"《电子证书》使用手册"和"注册与密码找回"做合并调整为"供应商新EDI安装手顺",见工单https://git.nri2k.svr/CIY/edi-web/issues/93
      // {
      //   path: '/common-help-ca',
      //   name:"common-help-ca",
      //   component: () => import('@/views/common-help/ca/index'),
      //   meta: {
      //     title: '《电子证书》使用手册',
      //     icon: null,
      //     requireAuth:false,//表示进入这个路由是否需要登录验证
      //   }
      // },
      {
        path: '/common-help-compatible',
        name:"common-help-compatible",
        component: () => import('@/views/common-help/compatible/index'),
        meta: {
          title: 'Microsoft Edge启动IE模式',
          icon: null,
          requireAuth:false,//表示进入这个路由是否需要登录验证
        }
      },
    ]
  },
  {
    path: '/403page',
    component: () => import('@/views/exception/403/index'),
    meta: {
      title: '403',
      icon: null,
      requireAuth:false,//表示进入这个路由是否需要登录验证
    }
  },
  {
    path: '*',
    component: () => import('@/views/exception/404'),
    meta: {
      title: '404',
      icon: null,
      requireAuth:false,//表示进入这个路由是否需要登录验证
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes-menu.js